import React, { useState } from "react";
import { Card, Row, Col, Form, Space } from "antd";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { TableUi, ButtonUi, CantidadColumn } from "../../ui";
import { DetalleCotizacionTableSummary } from "./DetalleCotizacionTableSummary";
import {
  detalleCotizacionClearActive,
  detalleCotizacionSetActive,
} from "../../../actions";
import { useDispatch } from "react-redux";
import { ItemDetalleModal } from "./modal/ItemDetalleModal";

const columns = (props) => {
  const { remove, handleEditar } = props;
  return [
    {
      title: "N°",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      key: "descripcion",
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad",
      key: "cantidad",
      align: "center",
      render: (value, record) => (
        <>
          <CantidadColumn
            cantidad={value}
            unidadmedida_nombre={record?.unidadmedida_nombre}
          />
        </>
      ),
    },
    {
      title: "V.Unitario",
      dataIndex: "valorunitario",
      key: "valorunitario",
      align: "right",
      render: (value, record) => <>{parseFloat(value).toFixed(2)}</>,
    },
    {
      title: "P.Unitario",
      dataIndex: "preciounitario",
      key: "preciounitario",
      align: "right",
      render: (value, record) => <>{parseFloat(value).toFixed(2)}</>,
    },
    {
      title: "Total",
      dataIndex: "valorventa",
      key: "valorventa",
      align: "right",
      render: (value, record) => <>{parseFloat(value).toFixed(2)}</>,
    },
    {
      title: "Opciones",
      dataIndex: "opciones",
      key: "opciones",
      render: (text, record, index) => (
        <>
          <Space wrap>
            <ButtonUi
              typeUi={TipoButtonConstants.EditarTable}
              displayText={false}
              onClick={() => handleEditar(record)}
              size="small"
            />
            <ButtonUi
              typeUi={TipoButtonConstants.EliminarTable}
              displayText={false}
              onClick={() => remove(index)}
              size="small"
            />
          </Space>
        </>
      ),
    },
  ];
};
export const CotizacionFormDetalle = () => {
  const form = Form.useFormInstance();
  const dispatch = useDispatch();
  const detallecotizacion = Form.useWatch("detallecotizacion", form);
  const [open, setOpen] = useState(false);
  const handleOpenModal = () => setOpen(true);
  const handleCloseModal = () => {
    dispatch(detalleCotizacionClearActive());
    setOpen(false);
  };
  const handleEditar = (dataRow) => {
    dispatch(detalleCotizacionSetActive(dataRow));
    handleOpenModal();
  };
  return (
    <>
      <Card title="Detalle de Bienes/Servicios" size="small" className="mt-2">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={20}>
            <Form.List
              name="detallecotizacion"
              rules={[
                {
                  validator: async (_, value) => {
                    if (value < 1)
                      return Promise.reject(
                        new Error(
                          "Ingrese al menos un item en el detalle de cotización",
                        ),
                      );
                  },
                },
              ]}
            >
              {(fields, { add, remove }, { errors }) => (
                <>
                  <TableUi
                    rowKey="id"
                    size="small"
                    columns={columns({ remove, handleEditar })}
                    data={detallecotizacion}
                    title={() => (
                      <ButtonUi
                        typeUi={TipoButtonConstants.AgregarTable}
                        onClick={handleOpenModal}
                        size="small"
                      />
                    )}
                    summary={() => (
                      <DetalleCotizacionTableSummary data={detallecotizacion} />
                    )}
                  />
                  <Form.Item className="ui-errorlist">
                    <Form.ErrorList errors={errors} />
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Col>
        </Row>
      </Card>
      <ItemDetalleModal open={open} onCancelModal={handleCloseModal} />
    </>
  );
};
